import { Component, inject, Input, OnInit } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import {
  PageableFilter,
  PageableRequest,
  ProductControllerService,
  ProductVariantShippingOrderDetail,
  ShippingOrderControllerService
} from 'src/app/admin-api';
import { PageContent, TableColumn } from '../table';

@Component({
  selector: 'app-product-movements',
  templateUrl: './product-movements.component.html',
  styleUrls: ['./product-movements.component.scss']
})
export class ProductMovementsComponent implements OnInit {
  @Input()
  productId = 0;

  public productService = inject(ProductControllerService);
  private shippingOrderService = inject(ShippingOrderControllerService);

  cols = [
    new TableColumn.Builder()
      .setHeader('Pedido')
      .setField('shippingOrderId')
      .setType('number')
      .setRouterLink('/products/shipping-orders/')
      .setRouterLinkFieldName('shippingOrderId')
      .build(),
    new TableColumn.Builder()
      .setHeader('Assinante')
      .setField('personName')
      .setSortable(true)
      .setType('text')
      .setRouterLink('/users/person/')
      .setRouterLinkFieldName('personId')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Id da Edição')
      .setField('editionId')
      .setSortable(true)
      .setType('number')
      .build(),
    new TableColumn.Builder()
      .setHeader('Edição')
      .setField('theme')
      .setSortable(true)
      .setType('text')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Frete (troca)')
      .setField('shippingTotal')
      .setSortable(true)
      .setType('currency')
      .setCondition('gt')
      .build(),
    new TableColumn.Builder()
      .setHeader('Tipo')
      .setField('shippingOrderTypeName')
      .setSortable(true)
      .setType('text')
      .build(),
    new TableColumn.Builder()
      .setHeader('Status')
      .setField('shippingOrderStatusName')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Data')
      .setField('dateCreated')
      .setSortable(true)
      .setType('date')
      .setCondition('between')
      .build(),
    new TableColumn.Builder()
      .setHeader('Status Millennium')
      .setField('statusOrderDescription')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Exportação millennium')
      .setField('dateSyncERP')
      .setSortable(true)
      .setType('date')
      .setCondition('between')
      .build()
  ];
  dropdownFilters = {};
  fixedFilters: Array<PageableFilter> | undefined;

  async ngOnInit() {
    await this.findShippingOrderTypes();
    this.fixedFilters = [
      {
        condition: 'equals',
        field: 'productId',
        value: this.productId?.toString(),
        fieldType: 'number'
      }
    ];
  }

  async findShippingOrderTypes(): Promise<void> {
    this.dropdownFilters['shippingOrderTypeName'] = await lastValueFrom(
      this.shippingOrderService
        .getShippingOrderTypes()
        .pipe(map((data) => data.result))
    );
  }

  findPage = async (request: PageableRequest) => {
    const type = request.filters?.find(
      (f) => f.field === 'shippingOrderTypeName'
    );
    if (type?.value) {
      request.filters.push({
        condition: 'equals',
        field: 'shippingOrderTypeId',
        fieldType: 'number',
        value: Number(type.value)
      });
    }
    return lastValueFrom(
      this.productService
        .getProductVariantsShippingOrders(request)
        .pipe(
          map(
            (data) =>
              data.result as PageContent<ProductVariantShippingOrderDetail>
          )
        )
    );
  };
}
